"use client";

import Logo from "./logo/Logo";
import NavActions from "./NavActions";
import { NAVBAR } from "./navbar.constants";

/** Compact top bar: logo + locale + book meeting (always fixed). */
export default function MobileTopBar() {
  return (
    <div
      className={`${NAVBAR.maxWidth} w-full mx-auto flex justify-between items-center gap-3`}
    >
      <Logo classNameForText="hidden" />
      <NavActions variant="compact" />
    </div>
  );
}
